module.exports = __webpack_public_path__ + "static/media/1-3-v-betleme-porodila.023892f6.jpg";